export enum PortTypeEnum {
    Both = "Both",
    TCP = "TCP",
    UDP = "UDP"
}